<template>
  <vs-row>
    <form>
      <vs-row>
        <vs-input label-placeholder="Átvételi mód név (kötelező)" v-model="selected.ShippingName"></vs-input>
      </vs-row>
      <vs-row class="justify-content-center">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés</vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "new_shipping",
  props: ['selected'],
  data() {
    return {}
  },
  methods: {
    save() {
      let self = this;
      axiosInstance
          .put('admin/shippingController.php', self.selected, {
            withCredentials: true,
          })
          .then((resp) => {
            self.$vs.notify({
              title: 'Rendszerüzenet',
              position: 'top-right',
              text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
              color: resp.data.status === 'OK' ? 'success' : 'danger',
              icon: resp.data.status === 'OK' ? 'check_box' : 'error'
            });
            self.$parent.$emit('closemodal');
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    isNotSaveable() {
      return !this.selected.ShippingName;
    }
  }
}
</script>

<style scoped>
.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}
</style>